/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

module.exports = Model({
	name: "remotebraceletscanner",
	init: init,
	uninit: uninit,
	listeners: listeners,

	_finding: null,

	stop_scanning: stop_scanning,
});

function init() {
	this._finding = [];
	this.push(false);
	this._manageGroupTracker = this.dispatcher.createTracker();
}

function uninit(){
	this._manageGroupTracker.off();
	this._manageGroupTracker = null;
}

function listeners() {
	return {
		"mqtt:$/device/scan/start": begin_scanning,
		"mqtt:$/device/scan/stop": stop_scanning,
		"bluetooth:scanned": notify_scanned,
		"bracelet:connected": notify_connected,
		"braceletfinder:updated": handle_finder_updated,
		"ownmanagegroup:updated": handle_own_managegroup_updated
	};
}

function begin_scanning() {
	if (this.data) return;
	this.emit("bluetooth:trigger:initialize");
	this.push(true);
	this.emit("bluetoothscanner:trigger:start");
}

function stop_scanning() {
	if (!this.data) return;
	this.push(false);
	if (this._finding.length) return;
	this.emit("bluetoothscanner:trigger:stop");
}

function notify_connected(data) {
	if (!this.data) return;
	this.emit("$mqtt:$/device/scan/connected", {
		mac: data.bracelet
	});
	this.stop_scanning();
}

function notify_scanned(device) {
	if (!this.data) return;

	// Don't send devices without a human readable name
	if (!device.name) return;
	this.emit("$mqtt:$/device/scan/scanned", device);
}

function handle_finder_updated(finding) {
	this._finding = finding;
}

function handle_own_managegroup_updated(group){
	const tracker = this._manageGroupTracker;
	tracker.off();
	if(!group) return;
	if(Array.isArray(group)) {
		group.forEach(g=>{
			tracker.on(`mqtt:managegroup/${g}/patient/u/${this.config.id}/device/scan/start`, begin_scanning.bind(this));
			tracker.on(`mqtt:managegroup/${g}/patient/u/${this.config.id}/device/scan/stop`, stop_scanning.bind(this));
		});
	} else {
		tracker.on(`mqtt:managegroup/${group}/patient/u/${this.config.id}/device/scan/start`, begin_scanning.bind(this));
		tracker.on(`mqtt:managegroup/${group}/patient/u/${this.config.id}/device/scan/stop`, stop_scanning.bind(this));
	}
}
